import React from 'react';


const EmailsContent = (props: any) => {
    return <>emails content coming soon!</>
}

export default EmailsContent;